import React from 'react';
import { History } from '../../router/History';
import Router from '../../router/Router';
export default class Link extends React.Component<{to:string,target?:string,className?:any}>
{
	anchor;
	history = new History();
	// componentDidMount()
	// {
	// 	this.anchor?.addEventListener('click', this._click);
	// }

	// componentWillUnmount()
	// {
	// 	this.anchor?.removeEventListener('click', this._click);
	// }

	private _click = (e) =>
	{
		let url = this.props.to;
		if(Router.getByID(url)) url = Router.getByID(url)
		console.log(this.props.to, url);
		if(Router.isValid(url))
		{
			e.preventDefault();
			e.stopPropagation();
			this.history.push(url);
		}
	}

	render()
	{
		let url = this.props.to;
		if(url) url = url.replace(/^\/+/, '');
		if(Router.getByID(url)) url = Router.getByID(url);
		let target;
		if(!Router.isValid(url))
		{
			target = '_blank';
		}
		return (<a ref={r => this.anchor = r} href={url} target={target} {...this.props} onClick={this._click}>{this.props.children}</a>);
	}
}